<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Timesheet Adjustment</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-timesheet-filter [filterFields]="fields" [chequeNumbers]="chequeNumbers"
                        (searchEvent)="onSearch($event)"></ppl-timesheet-filter>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Adjust</strong> and <strong>Void</strong> actions, please select the
                                applicable timesheet.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(hasSearched && !listReloading) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="timesheets" [customDataLoaded]="true" [enableActions]="false" [from]="'timesheet'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" [actionButtons]="actionButtons"
                        [enablePageActions]="!isReadOnly" [timesheetFor]="'pendedTimesheet'" [listButton]="isReadOnly ? [] : buttons"
                        (actionInvoked)="gridAction($event)" (onPageLoad)="onPageLoad($event)"
                        (rowCellClicked)="onCellClicked($event)" [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else if(!listReloading) {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div class="filter-panel">
    <ng-template #timesheetAdjustVoidDialog let-cancel="cancel">
        <ppl-timesheet-adjust-void-entry [timesheetData]="timesheetData" [searchParams]="appliedFilters"
            [actionData]="selectedAction" (timesheetAdjustedOrVoided)="timesheetAdjustedOrVoided($event)"
            [source]="'payroll'"></ppl-timesheet-adjust-void-entry>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
        <ppl-authorization-details [authorizationId]="selectedAuthorizationId" [pageSource]="'timesheet'" [isReadOnly]="true"></ppl-authorization-details>
    </ng-template>
</div>

